<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputPreview'
export default {
  name: 'DRealNamePreview',
  extends: compoment
}
</script>
